import { useState, useEffect } from "@wordpress/element";
import cssGenerator from "../styleGenerator";

const cssProperties = ["background", "bgColor", "color", "fontSize", "fontWeight", "backgroundColor", "border", "boxShadow", "width", "height", "display", "margin", "padding", "position", "overflow", "opacity", "flex", "columns"];

const useStyleRenderer = (styles = {}, parentSelector) => {
  const [CSS, setCSS] = useState("");

  useEffect(() => {
    // console.log(styles);
    setCSS(cssGenerator(extractStyles(styles), parentSelector));
  }, [styles]);

  const extractStyles = (styles) => {
    const tempStyle = {};
    Object.entries(styles).map(([key, value]) => {
      if (typeof value === "object") {
        if (key.includes("Style")) {
          tempStyle[key.replace("Style", "")] = value;
        } else if (key.includes("style")) {
          tempStyle[key.replace("style", "")] = value;
        } else if (key.includes(".") || key.includes("#")) {
          tempStyle[key] = value;
        }
      }
    });
    return tempStyle;
  };

  return { CSS, extractStyles };
};

export default useStyleRenderer;
